import { EASTERN_EDIT, EASTERN_MENU, slugify } from '@/lib/store';
export const CATEGORY_GROUPS = [
  { parent: EASTERN_MENU[0].label, items: [...EASTERN_MENU[0].children, ...EASTERN_EDIT] },
  ...EASTERN_MENU.slice(1).map(item => ({ parent: item.label, items: [] as string[] })),
];
export const ALL_CATEGORY_LABELS = [...EASTERN_MENU.map(item => item.label), ...new Set(CATEGORY_GROUPS.flatMap(group => group.items))];
export const categoryHref = (label: string, subfilter?: string) =>
  `/brands/ethnc/${slugify(label)}${subfilter ? `/${slugify(subfilter)}` : ""}`;